/* eslint-disable max-len */
import React from 'react'

const StatsIcon = ({ariaHidden}) => (
  <svg
    aria-hidden={ariaHidden}
    width="24px"
    height="24px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g fill="#CCCCCC">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 15.3333C6 16.436 5.10267 17.3333 4 17.3333C2.89733 17.3333 2 16.436 2 15.3333C2 14.2307 2.89733 13.3333 4 13.3333C4.372 13.3333 4.716 13.4427 5.016 13.62L10.1307 9.356C10.0493 9.14 10 8.91067 10 8.66667C10 7.564 10.8973 6.66667 12 6.66667C13.0893 6.66667 13.9747 7.544 13.996 8.63067L18.4307 10.108C18.7987 9.64 19.3613 9.33333 20 9.33333C20.252 9.33333 20.4933 9.38533 20.716 9.47067L26.272 2.98933C26.104 2.696 26 2.36133 26 2C26 0.897333 26.8973 0 28 0C29.1027 0 30 0.897333 30 2C30 3.10267 29.1027 4 28 4C27.7467 4 27.5053 3.948 27.2827 3.86133L21.7267 10.3427C21.896 10.636 22 10.972 22 11.3333C22 12.436 21.1027 13.3333 20 13.3333C18.9107 13.3333 18.024 12.456 18.004 11.3693L13.5693 9.892C13.2027 10.36 12.6387 10.6667 12 10.6667C11.628 10.6667 11.284 10.5573 10.984 10.38L5.86933 14.644C5.95067 14.86 6 15.0893 6 15.3333ZM30.6667 30.6667H31.3333C31.7013 30.6667 32 30.9653 32 31.3333C32 31.7013 31.7013 32 31.3333 32H30H26H22H18H14H10H6H2H0.666667C0.298667 32 0 31.7013 0 31.3333C0 30.9653 0.298667 30.6667 0.666667 30.6667H1.33333V24.6667C1.33333 24.2987 1.632 24 2 24H6C6.368 24 6.66667 24.2987 6.66667 24.6667V30.6667H9.33333V18C9.33333 17.632 9.632 17.3333 10 17.3333H14C14.368 17.3333 14.6667 17.632 14.6667 18V30.6667H17.3333V20.6667C17.3333 20.2987 17.632 20 18 20H22C22.368 20 22.6667 20.2987 22.6667 20.6667V30.6667H25.3333V11.3333C25.3333 10.9653 25.632 10.6667 26 10.6667H30C30.368 10.6667 30.6667 10.9653 30.6667 11.3333V30.6667ZM2.66667 25.3333V30.6667H5.33333V25.3333H2.66667ZM10.6667 30.6667V18.6667H13.3333V30.6667H10.6667ZM18.6667 21.3333V30.6667H21.3333V21.3333H18.6667ZM26.6667 30.6667V12H29.3333V30.6667H26.6667Z"
        />
      </g>
    </g>
  </svg>
)

export default StatsIcon
